/**
 * Learner-app subscription checkout (Phase SC-21f f6).
 */

import { api } from "../api";
import type { RazorpayCheckoutSuccess } from "../billing/razorpayCheckout";

export interface LearnerAppSubscriptionOrder {
  razorpay_order_id: string;
  amount: number;
  currency: string;
  receipt: string | null;
  key_id: string;
  pricing_mode: string;
  monthly_price_paise: number;
}

export interface VerifyRazorpayPaymentResult {
  verified: boolean;
  razorpay_order_id: string;
  razorpay_payment_id: string;
}

export async function createLearnerAppSubscriptionOrder(): Promise<LearnerAppSubscriptionOrder> {
  return api.post<LearnerAppSubscriptionOrder>("/api/me/learner-app/subscription");
}

export async function verifyLearnerAppPayment(
  payload: RazorpayCheckoutSuccess,
): Promise<VerifyRazorpayPaymentResult> {
  return api.post<VerifyRazorpayPaymentResult>("/billing/razorpay/payments/verify", {
    razorpay_order_id: payload.razorpay_order_id,
    razorpay_payment_id: payload.razorpay_payment_id,
    razorpay_signature: payload.razorpay_signature,
  });
}
